import * as React from "react";
import { ErrorListItem } from "./ErrorListItem";
import "./ErrorList.scss";
export const ErrorListComponent = ({ errorSet }) => {
    const orderComponentErrors = (fieldName, errors) => {
        let orderedErrors = [];
        let keys = Object.keys(errors);
        if (typeof errors !== "undefined") {
            orderedErrors = errors.errors.map(error => ({
                source: fieldName,
                error
            }));
            for (let i = 0; i < keys.length; i++) {
                let fieldName = keys[i];
                if (fieldName !== "errors") {
                    orderedErrors = orderedErrors.concat(orderComponentErrors(fieldName, errors[fieldName]));
                }
            }
        }
        return orderedErrors;
    };
    const orderErrors = () => {
        let orderedErrors = [];
        let keys = Object.keys(errorSet);
        orderedErrors = errorSet.errors.map(error => {
            return { error: error };
        });
        for (let i = 0; i < keys.length; i++) {
            let fieldName = keys[i];
            if (fieldName !== "errors") {
                orderedErrors = orderedErrors.concat(orderComponentErrors(fieldName, errorSet[fieldName]));
            }
        }
        return orderedErrors;
    };
    if (errorSet) {
        const orderedErrors = orderErrors();
        const errorList = orderedErrors.map((errorObject, i) => {
            if (errorObject.source) {
                return (React.createElement(ErrorListItem, { className: "error-list-component-item", key: errorObject.source + "_" + i, source: errorObject.source, error: errorObject.error }));
            }
            else {
                return (React.createElement(ErrorListItem, { className: "error-list-component-item", key: i, error: errorObject.error }));
            }
        });
        return React.createElement("ul", { className: "error-list-component" }, errorList);
    }
    else {
        return null;
    }
};
//# sourceMappingURL=ErrorListComponent.js.map